import styled, { css } from 'styled-components';

import media from '~/utils/media';
import checkboxStd from '~/components/styled/checkbox';

export const Wrap = styled.div`

`;

export const BottomWrap = styled.div`
  position: relative;

  > button {
    border: 0;
    background: transparent;
    width: 90%;
    height: 10%;
    position: absolute;
    top: 6%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const QuizWrap = styled.div`
  position: relative;

  > button {
    border: 0;
    background: transparent;
    width: 90%;
    height: 14%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    &.a-1 {
      bottom: 25%;
    }

    &.a-2 {
      bottom: 9%;
    }
  }
`;

export const AgreeWrap = styled.div`
  padding: 4%;
  background-color: #000;
`;

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  width: 100%;
  
  ${media.pcLarge`
    font-size: 20px;
  `}

  ${media.tabletLarge`
    font-size: 20px;
  `}

  ${media.tabletSmall`
    font-size: 20px;
  `}

  ${media.mobileLarge`
    font-size: 14px;
  `}

  ${media.mobileMid`
    font-size: 14px;
  `}

  ${media.mobileSmall`
    font-size: 14px;
  `}

  font-weight: 700;
  color: #fff;
  letter-spacing: -1px;

  > svg {
    margin-left: 2%;

    ${({ isOpen }) => isOpen ? css`
      transform: rotate(-180deg);
      transition: transform 150ms ease;
    ` : css`
      transform: rotate(0deg);
      transition: transform 150ms ease;
    `}

    ${media.mobileSmall`
      width: 32px;
      height: 32px;
    `}

    ${media.pcLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletSmall`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileLarge`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileMid`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileSmall`
      width: 20px;
      height: 20px;
    `}
  }
`;

export const Checkbox = styled.input`
  ${checkboxStd};

  ${media.mobileSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.pcLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.mobileLarge`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileMid`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileSmall`
    width: 20px;
    height: 20px;
  `}

  margin-right: 2%;
`;

export const Ul = styled.ul`
  margin-top: 2%;

  > li {
    padding-left: 2%;

    ${media.pcLarge`
      font-size: 16px;
    `}

    ${media.tabletLarge`
      font-size: 16px;
    `}

    ${media.tabletSmall`
      font-size: 16px;
    `}

    ${media.mobileLarge`
      font-size: 12px;
    `}

    ${media.mobileMid`
      font-size: 12px;
    `}

    ${media.mobileSmall`
      font-size: 12px;
    `}

    ${media.pcLarge`
      line-height: 28px;
    `}

    ${media.tabletLarge`
      line-height: 28px;
    `}

    ${media.tabletSmall`
      line-height: 28px;
    `}

    ${media.mobileLarge`
      line-height: 20px;
    `}

    ${media.mobileMid`
      line-height: 20px;
    `}

    ${media.mobileSmall`
      line-height: 20px;
    `}

    color: #fff;
    letter-spacing: -1px;
  }
`;
